import infoIcon from "../img/info.svg";

export const WINDOW_IDS = {
  BIO: "bio",
  IMAGE: "image",
  PROJECTS: "projectsBin",
  ELDEST: "eldestOne",
  NOTICE: "notice",
};

export const TASKBAR_HEIGHT = 50;
export const MOBILE_BREAKPOINT = 660;
export const MIN_WINDOW_WIDTH = 200;
export const MIN_WINDOW_HEIGHT = 160;
export const CASCADE_OFFSET = 32;
export const MOBILE_WINDOW_MARGIN = 16;

export const START_BUTTON_SRC = "https://i.ibb.co/VJNDYdN/Start-Win2.png";

export const WINDOW_MENU = [
  { underline: "F", rest: "ile" },
  { underline: "E", rest: "dit" },
  { underline: "S", rest: "earch" },
  { underline: "H", rest: "elp" },
];

export const WINDOWS = [
  {
    id: WINDOW_IDS.BIO,
    title: "About me - Notepad",
    taskbarTitle: "About Me - Notepad",
    desktopLabel: "Notepad",
    icon: "https://i.ibb.co/HNbCz7w/notepad-document.png",
    iconAlt: "notepad",
    windowIconAlt: "notepad",
    desktopClass: "notepadIcon",
    defaultWidth: 650,
    defaultHeight: 450,
    tabletWidth: 500,
    tabletHeight: 325,
  },
  {
    id: WINDOW_IDS.IMAGE,
    title: "meChilling.png - Image",
    taskbarTitle: "meChilling.png - Image",
    desktopLabel: "Image",
    icon: "https://i.ibb.co/mHGb879/sheet-with-painting.png",
    iconAlt: "myPhoto",
    windowIconAlt: "pic",
    desktopClass: "imageIcon",
    defaultWidth: 300,
    defaultHeight: 400,
    tabletWidth: 250,
    tabletHeight: 330,
  },
  {
    id: WINDOW_IDS.PROJECTS,
    title: "Projects Bin",
    taskbarTitle: "Projects Bin",
    desktopLabel: "Projects Bin",
    icon: "https://i.ibb.co/0jc9DLv/recycle-bin-with-pap.png",
    iconAlt: "recycleBin",
    windowIconAlt: "recycleBin",
    desktopClass: "projectsBinIcon",
    defaultWidth: 650,
    defaultHeight: 450,
    tabletWidth: 500,
    tabletHeight: 325,
  },
  {
    id: WINDOW_IDS.ELDEST,
    title: "eldest one",
    taskbarTitle: "eldest one",
    icon: "https://i.ibb.co/q0YhQgR/opened-folder.png",
    iconAlt: "folder",
    windowIconAlt: "folder",
    showOnDesktop: false,
    initialStatus: "closed",
    defaultWidth: 650,
    defaultHeight: 450,
    tabletWidth: 500,
    tabletHeight: 325,
  },
  {
    id: WINDOW_IDS.NOTICE,
    title: "Information",
    taskbarTitle: "Information",
    icon: infoIcon,
    iconAlt: "info",
    windowIconAlt: "info",
    showOnDesktop: false,
    mobileOnly: true,
    defaultWidth: 420,
    defaultHeight: 240,
    tabletWidth: 420,
    tabletHeight: 240,
  },
];

export const WINDOW_BY_ID = WINDOWS.reduce((acc, window) => {
  acc[window.id] = window;
  return acc;
}, {});
